import axios, { AxiosInstance } from 'axios'
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID
const audience = process.env.REACT_APP_AUTH0_AUDIENCE

const http: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  timeout: 99999999
})

http.interceptors.request.use(req => {
  const userInfos = JSON.parse(
    localStorage.getItem(
      `@@auth0spajs@@::${clientId}::${audience}::openid profile email offline_access`
    )
  )

  // const token = Cookies.get('SCLToken')
  //   ? `Bearer ${Cookies.get('SCLToken')}`
  //   : 'Bearer'
  // if (Cookies.get('SCLToken')) {
  //   req.headers = {
  //     Authorization: token
  //   }
  // }

  // const accessToken = JSON.parse(localStorage.getItem('@access_token_rl'))

  if (userInfos) {
    req.headers.Authorization = `Bearer ${
      userInfos ? userInfos.body?.access_token : ''
    }`
  }
  return req
})
// http.interceptors.response.use(
//   response => {
//     return response
//   },
//   error => {
//     const {
//       config,
//       response: { status }
//     } = error
//     const originalRequest = config

//     if (status === 401) {
//       const tokenSSO = localStorage.getItem('userSSO')

//       if (!isRefreshing) {
//         isRefreshing = true
//         const token = Cookies.get('SCLToken')
//         const refreshToken = Cookies.get('SCLRefreshToken')
//         let isExpired = false
//         const decodedToken: any = decodeToken(token)
//         const dateNow = new Date()
//         const time = dateNow.getTime() / 1000

//         if (decodedToken.exp + 60 < time) {
//           isExpired = true
//         }
//         isRefreshing = true
//         if (!isExpired) {
//           if (decodedToken.exp < time) {
//             http
//               .post('v1/Auth/RefreshToken', {
//                 token,
//                 refreshToken
//               })
//               .then((data: any) => {
//                 isRefreshing = false
//                 Cookies.set('SCLToken', data.data.data.token)
//                 Cookies.set('SCLRefreshToken', data.data.data.refreshToken)
//                 onRrefreshed(data.data.data.token)
//               })
//           } else {
//             isRefreshing = false
//           }
//         } else {
//           http
//             .post('v1/Auth/Login', { token: `${tokenSSO}` })
//             .then((data: any) => {
//               isRefreshing = false
//               Cookies.set('SCLToken', data.data.data.token)
//               Cookies.set('SCLRefreshToken', data.data.data.refreshToken)
//               onRrefreshed(data.data.data.token)
//             })
//         }
//       }

//       const retryOrigReq = new Promise(resolve => {
//         subscribeTokenRefresh((token: any) => {
//           originalRequest.headers.Authorization = 'Bearer ' + token
//           resolve(axios(originalRequest))
//         })
//       })
//       return retryOrigReq
//     } else {
//       return Promise.reject(error)
//     }
//   }
// )

// http.interceptors.response.use(
//   response => {
//     return response
//   },
//   error => {
//     const {
//       config,
//       response: { status }
//     } = error
//     const originalRequest = config

//     // if (status === 406) {
//     //   const accessToken = useAccessToken().getToken()
//     //   const tokenSSO = localStorage.getItem('userSSO')
//     //   console.log(accessToken)
//     //   if (!isRefreshingProfile) {
//     //     isRefreshingProfile = true
//     //     isRefreshingProfile = true
//     //     http
//     //       .post('v1/Auth/Login', { token: `${tokenSSO}` })
//     //       .then((data: any) => {
//     //         isRefreshing = false
//     //         Cookies.set('SCLToken', data.data.data.token)
//     //         Cookies.set('SCLRefreshToken', data.data.data.refreshToken)
//     //         onRrefreshed(data.data.data.token)
//     //         window.location.reload()
//     //       })
//     //   }

//     //   const retryOrigReq = new Promise(resolve => {
//     //     subscribeTokenRefresh((token: any) => {
//     //       originalRequest.headers.Authorization = 'Bearer ' + token
//     //       resolve(axios(originalRequest))
//     //     })
//     //   })
//     //   return retryOrigReq
//     // } else {
//     //   return Promise.reject(error)
//     // }
//   }
// )

// http.interceptors.response.use(
//   res => {
//     return res
//   },
//   async err => {
//     if (err.response === null) {
//       toast({
//         title: 'Error!',
//         description: 'Ocorreu um erro interno',
//         status: 'error',
//         duration: 5000,
//         isClosable: true,
//         position: 'bottom-right'
//       })
//       return
//     }
//     if (err.response.status === 500) {
//       toast({
//         title: 'Error!',
//         description: 'Ocorreu um erro interno',
//         status: 'error',
//         duration: 5000,
//         isClosable: true,
//         position: 'bottom-right'
//       })
//       return
//     }
//     return Promise.reject(err)
//   }
// )

export default http
